import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { DateTime } from 'luxon';

interface SelfServiceAuthStore {
  token: string | undefined;
  expiresAt: string | undefined;
  setToken: (token: string | undefined, expiresAt: string | undefined) => void;
  isTokenValid: () => boolean;
  logout: () => void;
}

export const useSelfServiceAuth = create<SelfServiceAuthStore>()(
  devtools(
    persist(
      (set, get) => ({
        token: undefined,
        expiresAt: undefined,
        setToken: (token, expiresAt) => {
          if (!token) {
            set({ token: undefined, expiresAt: undefined });
            return;
          }
          set({ token, expiresAt });
        },
        isTokenValid: () => {
          const { expiresAt, token } = get();
          if (!expiresAt || !token) return false;

          const expires = DateTime.fromISO(expiresAt).toLocal();
          const diff = expires.diffNow().toMillis();
          return diff > 0;
        },
        logout: () => {
          set({ token: undefined, expiresAt: undefined });
        },
      }),
      {
        name: 'self-service-auth',
        partialize: (state) => ({
          token: state.token,
          expiresAt: state.expiresAt,
        }),
      },
    ),
  ),
);
